<!-- Splash: carga inicial -->
<div *ngIf="isInitialPlanLoading" class="sub-splash">
  <div class="sub-splash__card">
    <div class="sub-splash__icon-wrap">
      <mat-icon>star</mat-icon>
    </div>
    <div class="sub-splash__dots">
      <span></span><span></span><span></span>
    </div>
    <p class="sub-splash__title">Cargando tu plan</p>
    <p class="sub-splash__sub">Por favor espera un momento…</p>
  </div>
</div>

<!-- Overlay: acción en curso (activar/desactivar módulo) -->
<div *ngIf="isBookingProActionLoading" class="sub-action-overlay">
  <div class="sub-action-card">
    <div class="sub-action__icon-wrap">
      <mat-icon>settings</mat-icon>
    </div>
    <div class="sub-splash__dots">
      <span></span><span></span><span></span>
    </div>
    <p class="sub-action__title">{{ bookingProLoadingHeader }}</p>
    <p class="sub-action__sub">{{ bookingProLoadingBody }}</p>
  </div>
</div>

<div *ngIf="isLoading" class="preinvoice-modal">
  <div class="preinvoice-box">
    <mat-spinner diameter="40" color="primary" style="margin: 0 auto 16px;"></mat-spinner>
    <div class="preinvoice-header">Un momento…</div>
    <div class="preinvoice-body">Estamos actualizando tu suscripción, no cierres esta ventana.</div>
  </div>
</div>

<div class="container-fluid" *ngIf="!isInitialPlanLoading && !isPaymentPendingMode()">
  <div class="content-body">
    <!-- BEGIN: CurrentPlan -->
    <section class="plan-card" data-purpose="current-subscription-status">
      <div class="plan-details">
        <span class="badge-current">Mi Plan Actual</span>
        <h2 class="plan-name">{{ getHeaderPlanName() }}</h2>
        <div class="plan-status">
          <span class="status-dot" [ngClass]="{'status-dot-trial': isTrialMode(), 'status-dot-canceled': isCanceledStatus()}"></span>
          Estado: {{ getHeaderStatusLabel() }}
        </div>
        <div class="trial-days-badge" *ngIf="isTrialMode()">
          <mat-icon style="font-size:14px;width:16px;height:16px;vertical-align:middle">schedule</mat-icon>
          {{ getTrialDaysRemaining() }} días restantes de prueba
        </div>
      </div>
      <div style="display: flex; align-items: center;">
        <div class="plan-price-block">
          <div class="price-value" *ngIf="!isInlinePlanSelectionMode()">{{ getHeaderMonthlyPrice() | number:'1.2-2' }}€<span class="price-period">{{ getHeaderPeriodText() }}</span></div>
          <div class="renewal-date" *ngIf="!isInlinePlanSelectionMode() && hasHeaderDiscount() && getHeaderBasePrice() > getHeaderMonthlyPrice()">
            Precio base: {{ getHeaderBasePrice() | number:'1.2-2' }}€{{ getHeaderPeriodText() }}
          </div>
          <div class="renewal-date" *ngIf="!isInlinePlanSelectionMode() && hasHeaderDiscount()">
            Descuento activo{{ getHeaderDiscountName() ? ': ' + getHeaderDiscountName() : '' }}
          </div>
          <div class="renewal-date" *ngIf="isTrialMode()">
            Fin de prueba:
            <span *ngIf="getTrialPeriodEnd(); else noTrialEndDate">
              {{ getTrialPeriodEnd() | date:'d \'de\' MMMM, y' }}
            </span>
            <ng-template #noTrialEndDate>Sin fecha</ng-template>
          </div>
          <div class="renewal-date" *ngIf="hasNoActiveSubscription()">
            Elige un plan de pago para activar tu cuenta.
          </div>
          <div class="renewal-date" *ngIf="!isInlinePlanSelectionMode() && isScheduledForCancellation()">
            <span class="cancellation-warning">Se cancelará el:</span>
            <span *ngIf="getHeaderNextRenewalDate(); else noRenewalDate">
              {{ getHeaderNextRenewalDate() | date:'d \'de\' MMMM, y' }}
            </span>
            <ng-template #noRenewalDate>Sin fecha</ng-template>
          </div>
          <div class="renewal-date" *ngIf="!isInlinePlanSelectionMode() && !isScheduledForCancellation()">
            Próxima renovación:
            <span *ngIf="getHeaderNextRenewalDate(); else noRenewalDate2">
              {{ getHeaderNextRenewalDate() | date:'d \'de\' MMMM, y' }}
              <span *ngIf="hasHeaderDiscount()"> (con descuento)</span>
              <span class="renewal-amount"> - {{ getHeaderNextRenewalAmount() | number:'1.2-2' }}€</span>
            </span>
            <ng-template #noRenewalDate2>Sin fecha</ng-template>
          </div>
          <div class="renewal-date" *ngIf="!isInlinePlanSelectionMode()">
            <button mat-button color="primary" (click)="openPaymentHistoryDialog()" class="payment-history-btn">
              <mat-icon>history</mat-icon>
              Ver histórico de pagos
            </button>
          </div>
        </div>
      </div>
      <div class="pending-downgrade-banner" *ngIf="hasPendingDowngrade()" data-purpose="pending-downgrade-banner">
        <div class="pending-downgrade-text">
          <mat-icon style="font-size:18px;width:20px;height:20px;vertical-align:middle">info</mat-icon>
          Tu plan pasará a <strong>{{ getPendingDowngradePlanTitle() }} ({{ getPendingDowngradeIntervalText() }})</strong> el
          <strong>{{ getPendingDowngradeEffectiveDate() | date:'d \'de\' MMMM, y' }}</strong>.
          Hasta entonces sigues disfrutando de tu plan actual.
        </div>
        <button type="button" class="btn-cancel" [disabled]="isPendingDowngradeLoading" (click)="onCancelPendingDowngrade()">
          Cancelar cambio
        </button>
      </div>
      <div class="fiscal-profile-banner" *ngIf="hasFiscalProfileIssues()" data-purpose="fiscal-profile-banner">
        <div class="fiscal-profile-text">
          <mat-icon>warning</mat-icon>
          <span>Tus datos fiscales están incompletos. Complétalos para poder contratar y recibir tus facturas.</span>
        </div>
        <button mat-flat-button type="button" class="cf-btn cf-btn--primary" (click)="completeFiscalProfile()">
          <mat-icon>arrow_forward</mat-icon>
          Completar datos
        </button>
      </div>
    </section>
    <!-- END: CurrentPlan -->
    <!-- BEGIN: PromotionalSection -->
    <section class="promotional-modules" *ngIf="!isInlinePlanSelectionMode() && !isSelectingPlan()">
      <div class="section-label">
        <div class="label-icon"></div>
        Módulos en Promoción
      </div>
      <div class="promo-grid">
        <div class="promo-card" *ngFor="let module of promotionModules; trackBy: trackByIndex">
          <div class="promo-icon-box">{{ module.icon }}</div>
          <h3 class="promo-title">{{ module.title }}</h3>
          <p class="promo-desc">{{ module.description }}</p>
          <div class="renewal-date" *ngIf="isPromotionActive(module) && getPromotionNextRenewalDate(module)">
            <span *ngIf="isPromotionScheduledForCancellation(module)" class="cancellation-warning">Se cancelará el: </span>
            <span *ngIf="!isPromotionScheduledForCancellation(module)">Próxima renovación: </span>
            {{ getPromotionNextRenewalDate(module) | date:'d \'de\' MMMM, y' }}
            <span *ngIf="!isPromotionScheduledForCancellation(module) && getPromotionNextRenewalAmount(module) != null"> - {{ getPromotionNextRenewalAmount(module) | number:'1.2-2' }}€</span>
          </div>
          <div class="promo-footer">
            <div>
              <span class="price-strike">{{ module.originalPrice | number:'1.0-2' }}€</span>
              <button type="button" class="btn-activate" [disabled]="isPromotionLoading(module)" (click)="onTogglePromotion(module)">{{ isPromotionActive(module) ? 'Desactivar' : 'Activar' }}</button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- END: PromotionalSection -->
    <!-- BEGIN: OCRSection -->
    <section class="ocr-card" *ngIf="!isInlinePlanSelectionMode() && !isSelectingPlan()" data-purpose="ocr-configuration">
      <div class="ocr-controls">
        <h3 class="ocr-title">Escaneo de Documentos (OCR)</h3>
        <p class="ocr-subtitle">Selecciona el paquete de páginas OCR que quieres comprar.</p>
        <div class="slider-container">
          <input
            class="ocr-range"
            type="range"
            min="0"
            [max]="ocrQuantitySteps.length - 1"
            step="1"
            [(ngModel)]="ocrSelectedIndex"
            (change)="onOcrRangeChanged()" />
          <div class="slider-labels">
              <span *ngFor="let step of ocrQuantitySteps; trackBy: trackByIndex">{{ step }} pág.</span>
          </div>
        </div>
      </div>
      <div class="estimation-box">
        <div class="estimation-label">Pago único estimado</div>
        <div class="estimation-value">{{ getSelectedOcrPages() | number:'1.0-0' }} <span>pág.</span></div>
        <div class="estimation-cost">{{ getSelectedOcrOneTimeCost() | number:'1.2-2' }}€</div>
      </div>
    </section>
    <!-- END: OCRSection -->

    <!-- BEGIN: InlineTrialPlanSelection -->
    <section *ngIf="isInlinePlanSelectionMode()" class="trial-plan-section">
      <div class="trial-plan-header">
        <h2 class="trial-plan-title" *ngIf="isTrialMode()">Elige tu plan para continuar</h2>
        <h2 class="trial-plan-title" *ngIf="hasNoActiveSubscription()">No tienes ninguna suscripción activa</h2>
        <p class="trial-plan-subtitle" *ngIf="isTrialMode()">Selecciona el plan que mejor se adapte a tu negocio.</p>
        <p class="trial-plan-subtitle" *ngIf="hasNoActiveSubscription()">Selecciona un plan de pago para activar tu cuenta.</p>
      </div>
      <div class="trial-plan-grid">
        <div class="trial-plan-cards">
          <ng-container *ngFor="let item of suscriptions; trackBy: trackByIndex">
            <button
              type="button"
              class="change-plan-card"
              *ngIf="!isCurrentFee(item)"
              [ngClass]="{ 'change-plan-card-active': isSuscriptionSelected(item) }"
              (click)="onSelectSuscription(item)">
              <div class="change-plan-card-top">
                <div class="change-plan-card-name">{{ item.title }}</div>
                <div class="change-plan-card-price">
                  {{ getCardPrice(item) | number:'1.2-2' }}€
                  <span>{{ shopping_cart.period === 'year' ? '/año' : '/mes' }}</span>
                </div>
              </div>
              <ul class="change-plan-features">
                <li *ngFor="let feature of item.features; trackBy: trackByIndex" [ngClass]="{'bold': feature.bold}">
                  <mat-icon *ngIf="feature.included">done</mat-icon>
                  <mat-icon *ngIf="!feature.included">close</mat-icon>
                  <span>{{ feature.description }}</span>
                </li>
              </ul>
            </button>
          </ng-container>

          <div class="change-plan-card trial-contact-card">
            <div class="change-plan-card-top">
              <div class="change-plan-card-name">¿Necesitas más capacidad?</div>
            </div>
            <div class="trial-contact-body">
              <p>Si tu operación es más grande, te preparamos un plan enterprise a medida.</p>
              <button type="button" class="btn btn-outline trial-contact-btn" (click)="openContactSalesDialog()">
                Contactar con ventas
              </button>
            </div>
          </div>
        </div>

        <div class="trial-plan-sidebar">
          <aside class="change-plan-summary">
            <h3>Carrito</h3>
            <div class="period-switch">
              <button type="button" [ngClass]="{ 'active': shopping_cart.period === 'month' }" (click)="onSelectMonthPeriod()">Mensual</button>
              <button type="button" [ngClass]="{ 'active': shopping_cart.period === 'year' }" (click)="onSelectAnualPeriod()">Anual</button>
            </div>
            <div class="summary-item" *ngIf="shopping_cart.suscription">
              <span>{{ shopping_cart.suscription.title }}</span>
              <strong>{{ getSubscriptionAmount() | number:'1.2-2' }} €</strong>
            </div>
            <div class="summary-item" *ngIf="!shopping_cart.suscription">
              <span class="text-muted">Selecciona un plan</span>
            </div>
            <div class="coupon-mini" *ngIf="shopping_cart.suscription">
              <button type="button" class="coupon-toggle-btn" (click)="toggleCouponInput()" *ngIf="!shopping_cart.couponApplied">
                {{ showCouponInput ? 'Cerrar cupón' : 'Añadir cupón' }}
              </button>
              <div class="coupon-input" *ngIf="showCouponInput && !shopping_cart.couponApplied">
                <div class="input-group">
                  <input type="text" class="form-control" [(ngModel)]="couponCode" placeholder="Código" />
                  <button type="button" class="btn btn-convfact" (click)="applyCoupon()">Aplicar</button>
                </div>
              </div>
              <div class="applied-coupon" *ngIf="shopping_cart.couponApplied">
                <span class="coupon-tag">{{ shopping_cart.couponCode }}</span>
                <button type="button" class="coupon-remove" (click)="removeCoupon()" aria-label="Quitar cupón" title="Quitar cupón">×</button>
              </div>
            </div>
            <div class="summary-item discount-row" *ngIf="shopping_cart.couponApplied && getCouponAmountDiscount() > 0">
              <span>Descuento cupón</span>
              <strong class="discount-amount">- {{ getCouponAmountDiscount() | number:'1.2-2' }} €</strong>
            </div>
            <div class="summary-total-row">
              <span>Total</span>
              <strong>{{ getTotal() | number:'1.2-2' }} €</strong>
            </div>
            <button type="button" class="btn btn-convfact w-100 mt-2" [disabled]="!shopping_cart.suscription" (click)="openConfirmPlanDialog()">
              Continuar
            </button>
            <p class="summary-legend">{{ getBillingText() }}</p>
          </aside>
        </div>
      </div>
    </section>
    <!-- END: InlineTrialPlanSelection -->

    <!-- BEGIN: ChangePlanSection (misma pantalla, sin capa superpuesta) -->
    <ng-container *ngIf="status_screen == StatusSubscription.SELECT_FEE && !isInlinePlanSelectionMode()">
    <div class="change-plan-section" id="change-plan-section">
      <div class="change-plan-shell">
        <div class="change-plan-header">
          <div>
            <h2 class="change-plan-title" *ngIf="!hasNoActiveSubscription()">Cambiar plan</h2>
            <h2 class="change-plan-title" *ngIf="hasNoActiveSubscription()">No tienes ninguna suscripción activa</h2>
            <p class="change-plan-subtitle" *ngIf="hasNoActiveSubscription()">Elige un plan de pago para activar tu cuenta.</p>
            <p class="change-plan-subtitle" *ngIf="!hasNoActiveSubscription() && isCurrentFree()">Compara planes, revisa el carrito y continúa cuando quieras.</p>
            <p class="change-plan-subtitle" *ngIf="!hasNoActiveSubscription() && !isCurrentFree()">Selecciona el plan que quieres activar.</p>
          </div>
          <div class="change-plan-header-actions">
            <button type="button" class="change-plan-close" (click)="openContactSalesDialog()">Contactar ventas</button>
            <button type="button" class="change-plan-close" *ngIf="!isCurrentFree()" (click)="status_screen = StatusSubscription.SELECT_SERVICE">Cerrar</button>
          </div>
        </div>

        <div class="change-plan-grid" [ngClass]="{ 'change-plan-grid-only-plans': !isCurrentFree() }">
          <div class="change-plan-cards">
            <ng-container *ngFor="let item of suscriptions; trackBy: trackByIndex">
            <button
              type="button"
              class="change-plan-card"
              *ngIf="!isCurrentFee(item)"
              [ngClass]="{ 'change-plan-card-active': isSuscriptionSelected(item) }"
              (click)="onSelectSuscription(item)">
              <div class="change-plan-card-top">
                <div class="change-plan-card-name">{{ item.title }}</div>
                <div class="change-plan-card-price">
                  {{ getCardPrice(item) | number:'1.2-2' }}€
                  <span>{{ shopping_cart.period === 'year' ? '/año' : '/mes' }}</span>
                </div>
              </div>
              <ul class="change-plan-features">
                <li *ngFor="let feature of item.features; trackBy: trackByIndex" [ngClass]="{'bold': feature.bold}">
                  <mat-icon *ngIf="feature.included">done</mat-icon>
                  <mat-icon *ngIf="!feature.included">close</mat-icon>
                  <span>{{ feature.description }}</span>
                </li>
              </ul>
            </button>
            </ng-container>
          </div>

          <aside class="change-plan-summary" *ngIf="isCurrentFree()">
            <h3>Carrito</h3>

            <div class="period-switch">
              <button type="button" [ngClass]="{ 'active': shopping_cart.period === 'month' }" (click)="onSelectMonthPeriod()">Mensual</button>
              <button type="button" [ngClass]="{ 'active': shopping_cart.period === 'year' }" (click)="onSelectAnualPeriod()">Anual</button>
            </div>

            <div class="summary-item" *ngIf="shopping_cart.suscription">
              <span>{{ shopping_cart.suscription.title }}</span>
              <strong>{{ getSubscriptionAmount() | number:'1.2-2' }} €</strong>
            </div>

            <div class="summary-item" *ngFor="let service of shopping_cart.services; trackBy: trackByIndex">
              <span>{{ service.title }}</span>
              <strong>{{ getAmountSelected(service.amount) }} €</strong>
            </div>

            <div class="summary-item" *ngIf="shopping_cart.quantity && shopping_cart.quantity > 0">
              <span>OCR ({{ shopping_cart.quantity }} págs.)</span>
              <strong>{{ getOcrTotal() | number:'1.2-2' }} €</strong>
            </div>

            <div class="coupon-mini" *ngIf="shopping_cart.suscription">
              <button type="button" class="coupon-toggle-btn" (click)="toggleCouponInput()" *ngIf="!shopping_cart.couponApplied">
                {{ showCouponInput ? 'Cerrar cupón' : 'Añadir cupón' }}
              </button>
              <div class="coupon-input" *ngIf="showCouponInput && !shopping_cart.couponApplied">
                <div class="input-group">
                  <input type="text" class="form-control" [(ngModel)]="couponCode" placeholder="Código" />
                  <button type="button" class="btn btn-convfact" (click)="applyCoupon()">Aplicar</button>
                </div>
              </div>
              <div class="applied-coupon" *ngIf="shopping_cart.couponApplied">
                <span class="coupon-tag">{{ shopping_cart.couponCode }}</span>
                <button type="button" class="coupon-remove" (click)="removeCoupon()" aria-label="Quitar cupón" title="Quitar cupón">×</button>
              </div>
            </div>

            <div class="summary-item discount-row" *ngIf="shopping_cart.couponApplied && getCouponAmountDiscount() > 0">
              <span>Descuento cupón</span>
              <strong class="discount-amount">- {{ getCouponAmountDiscount() | number:'1.2-2' }} €</strong>
            </div>

            <div class="summary-total-row">
              <span>Total</span>
              <strong>{{ getTotal() | number:'1.2-2' }} €</strong>
            </div>

            <button type="button" class="btn btn-convfact w-100 mt-2" [disabled]="!shopping_cart.suscription" (click)="openConfirmPlanDialog()">
              Continuar
            </button>
            <p class="summary-legend">{{ getBillingText() }}</p>
          </aside>

          <aside class="change-plan-enterprise" *ngIf="isCurrentFree()">
            <h3>¿Necesitas más capacidad?</h3>
            <p>Si tu operación es más grande, te preparamos un plan enterprise a medida con onboarding dedicado.</p>
            <button type="button" class="btn btn-outline" (click)="openContactSalesDialog()">
              Contactar con ventas
            </button>
          </aside>
        </div>
      </div>
    </div>
    </ng-container>
    <!-- END: ChangePlanSection -->
  </div>
</div>

<div class="container-fluid" *ngIf="!isInitialPlanLoading && !isPaymentPendingMode() && !isInlinePlanSelectionMode()">
  <!-- BEGIN: FooterButtons -->
  <footer class="footer-toolbar">
    <div class="footer-left">
      <button class="btn-footer btn-factuone" (click)="onChangeSelectFee()">🔄 Cambiar Plan</button>
      <button class="btn-footer btn-factuone" (click)="onChangePlanAnual()">{{ getChangePlanButtonText() }}</button>
      <button class="btn-footer btn-factuone" *ngIf="!isCurrentFree()" (click)="updateCardPayment()">💳 Cambiar Tarjeta</button>
      <button class="btn-footer btn-factuone" *ngIf="!isCurrentFree()" (click)="onOpenActiveCoupon()">🏷️ Añadir cupón</button>
    </div>
    <button type="button" class="btn-cancel" *ngIf="!isScheduledForCancellation()" (click)="onCancelAccountDialog()">Cancelar cuenta</button>
    <button type="button" class="btn-footer btn-factuone" *ngIf="isScheduledForCancellation()" (click)="onReactivateSubscription()">♻️ Reactivar suscripción</button>
  </footer>
  <!-- END: FooterButtons -->
</div>

<!-- BEGIN: PaymentPending (suscripción vencida no cancelada: past_due / unpaid / incomplete) -->
<ng-container *ngIf="!isInitialPlanLoading && isPaymentPendingMode()">
  <div class="container-fluid">
    <div class="content-body">
      <section class="plan-card payment-pending-card">
        <div class="payment-pending-header">
          <div class="plan-status payment-pending-status">
            <span class="status-dot status-dot-canceled"></span>
            Estado: {{ getHeaderStatusLabel() }}
          </div>
          <h2 class="plan-name">Tienes un pago pendiente</h2>
          <p class="change-plan-subtitle">{{ getPaymentIssueMessage() }}</p>
        </div>

        <div class="payment-pending-body">
          <div class="payment-pending-amount" *ngIf="getPaymentPendingAmount() > 0">
            <span>Importe pendiente</span>
            <strong>{{ getPaymentPendingAmount() | number:'1.2-2' }} €</strong>
          </div>

          <div class="payment-pending-reason" *ngIf="getPaymentIssueReason()">
            <mat-icon>error_outline</mat-icon>
            <span><strong>Motivo:</strong> {{ getPaymentIssueReason() }}</span>
          </div>

          <div class="payment-pending-actions">
            <button type="button" class="btn btn-convfact" (click)="payPendingInvoice()" [disabled]="isLoading">
              💳 Pagar ahora
            </button>
            <button type="button" class="btn-outline payment-pending-outline" (click)="updateCardPayment()" [disabled]="isLoading">
              Cambiar tarjeta
            </button>
          </div>

          <p class="payment-pending-legend">
            Al completar el pago se reactivará tu cuenta automáticamente. También puedes cambiar la tarjeta para que se reintente el cobro.
          </p>
        </div>
      </section>
    </div>
  </div>
</ng-container>
<!-- END: PaymentPending -->

